import {createTheme, MuiThemeProvider} from '@material-ui/core/styles';
import MUIDataTable from 'mui-datatables';
import React, {PureComponent} from 'react';

import toastr from "toastr";
import _ from 'lodash';
import {getCurrentUserId, getJwt} from '../../../services/authService';

import http from "../../../services/httpService";
import BillingInvoiceModal from "../../modals/BillingInvoiceModal";
import Theme from "../../../components/common/MuiTheme";

// import ReactGA from "react-ga";

import sizeMe from 'react-sizeme';
import ChartLoader from '../../utils/chart-loader';
import CustomToolbarSelect from '../contacts/CustomToolbarSelect';


const optionsPageSize = [
    {value: 10, text: 10},
    {value: 25, text: 25},
    {value: 50, text: 50},
];
/* Heights for every part of MultiPost post */
const multiPostGlobalPartHeight = 70;
const multiPostSinglePostHeight = 50;

/* Spinner Components for loader in blueprint tables */

const facebook_app_graph_url = process.env.REACT_APP_FB_URL;
const facebook_app_marketing_url = process.env.REACT_APP_FB_MARKETING_URL;

class BillingInvoices extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            user: this.props.user,
            campaigns: [],
            posts: [],
            totalPosts: '',
            totalPages: '',
            totalCampaigns: 0,
            total_subscribers: 0,
            selectedSource: '',
            push_subscribers: [],
            pageSize: 25,
            currentPage: 1,
            lastPage: false,
            lastPageSize: '',
            paging: '',
            selectedAdAccount: '',
            sortColumn: {
                path: "updated_at",
                order: "asc"
            },
            loader: false,
            selectedCampaignPerformance: 'MESSAGES',
            preview: '',
            forceTableRerender: false,
            selectedSubType: '',
            selectedSubTypeFinished: '',
            selectedType: '',
            selectedTypeFinished: '',
            rowHeights: [100, 100, 100, 100, 100],
            tableColumnsWidth: [],
            minTableWidth: 500,
            lastColumnWidth: '',
            showInvoiceModal: false,
            modalData: {
                id: '',
                item: '',
                name: '',
                address: '',
                country: '',
                email: '',
                date: '',
                discount: '',
                subtotal: '',
                total: '',
                project: '',
                price: '',
                quantity: '',
                tax: '',
                periodStart: '',
                periodEnd: '',
                yearly: false,
                type: '',
                companyName: '',
                vatNumber: ''
            }
        }

        toastr.options = {
            closeButton: true,
            positionClass: "toast-bottom-full-width",
            showDuration: "300",
            hideDuration: "1000",
            timeOut: "8000",
            extendedTimeOut: "1000",
        };
    }


    getPostsData = async () => {
        let projectId = await this.props.selectedSource;
        let user = await this.props.user;
        if (user && user.id && projectId) {
            try {
                await this.setState({loader: true, user})
                const pageSize = await this.state.pageSize;

                const result = await http.get('api/user/' + user.id + '/project/' + projectId + '/customers/invoices_charges?page=' + pageSize + '?page=' + this.state.currentPage, {headers: {authorization: getJwt()}});

                if(result?.data?.invoices){
                    await this.setState({
                        posts: result.data.invoices,
                        totalPosts: result.data.count,
                        loader: false

                    })
                }else{
                    this.setState({loader: false})
                }


                if (!this.state.posts) {
                    this.setState({loader: false})
                }

            } catch (ex) {
                if (ex.response && ex.response.status === 404)
                    // toastr.error("Something went wrong... Please refresh and try again.");
                    this.setState({loader: false, posts: [], rowHeights: []})
                if (ex.response && ex.response.status === 401) {
                    toastr.error(ex.response.data.message);
                    this.props.history.push('/logout');
                }
            }
        }

    }

    componentDidMount = async () => {
        // ReactGA.pageview(window.location.pathname + window.location.search);


        try {
            await this.getPostsData()
        } catch
            (ex) {
            if (ex.response && ex.response.status === 404)
                toastr.error("Something went wrong... Please refresh and try again.");
            if (ex.response && ex.response.status === 401) {
                toastr.error(ex.response.data.message);
                this.props.history.push('/logout');
            }
        }

    }


    componentDidUpdate() {
        if ((this.state.selectedSource !== this.props.selectedSource) || (this.props.user.id && !this.state.user)) {
            this.setState({
                selectedSource: this.props.selectedSource
            })
            this.getPostsData();
        }
    }

    handleDate = (date) => {
        if (this.state.user.locals) {
            let dateFormat = this.state.user.locals.date_format
            let timeFormat = this.state.user.locals.time_format
            // console.log('dateFormat: ', dateFormat)
            // console.log('timeFormat: ', timeFormat)
            // console.log('date: ', date)

            let dateOutput = '';
            let timeOutput = '';
            let dateTimeOutput = '';

            //date formatting according to user settings
            const dateObj = new Date(date);
            const month = dateObj.getMonth() < 10 ? '0' + dateObj.getMonth() : dateObj.getMonth();
            const day = String(dateObj.getDate()).padStart(2, '0');
            const year = dateObj.getFullYear();

            switch (dateFormat) {
                case 'DD-MM-YYYY':
                    dateOutput = day + '-' + month + '-' + year;
                    break;
                case 'MM-DD-YYYY':
                    dateOutput = month + '-' + day + '-' + year
                    break;
                case 'YYYY-MM-DD':
                    dateOutput = year + '-' + month + '-' + day
                    break;
            }
            //console.log('dateOutput: ', dateOutput)

            //time formatting according to user settings
            //
            // let hours = date.getHours();
            // let minutes = date.getMinutes();
            // let ampm = hours >= 12 ? 'PM' : 'AM';
            //
            // minutes = minutes < 10 ? '0' + minutes : minutes;
            //
            // if (timeFormat === 'AM/PM') {
            //     hours = hours % 12;
            //     hours = hours ? hours : 12; // the hour '0' should be '12'
            //     timeOutput = hours + ':' + minutes + ampm;
            // } else {
            //     timeOutput = hours + ':' + minutes
            // }

            dateTimeOutput = dateOutput
            //+ ' ' + timeOutput
            return dateTimeOutput
        } else {
            return date.toLocaleString()
        }

    }

    handlePageChange = async (number) => {
        let page = parseInt(number)
        if ((page !== 0) && (page !== this.state.lastPage)) {
            await this.setState({currentPage: page, loader: true});
            this.getPostsData()
        }
    };


// selectCampaignPerformanceOption = async (selected) =>{
//     await this.setState({
//         selectedCampaignPerformance: selected,
//     })
//     this.getPostsData()
// }
    capitalizeFirstLetter = (string) => {
        if (string) {
            const words = string.split(" ");

            for (let i = 0; i < words.length; i++) {
                words[i] = words[i][0].toUpperCase() + words[i].substr(1);
            }

            let wordsString = words.toString();
            let wordsFinal = wordsString.replace(',', ' ')
            //console.log('words: ', wordsFinal)
            return wordsFinal
        } else {
            return ''
        }
    }
    openModal = (rowIndex) => {
        //console.log('rowIndex: ', rowIndex)
        const item = this.state.posts[rowIndex];
        // console.log('INVOICES DATA: ', item);
        //let invoiceMetadata = JSON.parse(item.metadata.project)
        // console.log('invoice metadata: ', invoiceMetadata);
        let itemDescription = item.lineItems[0] && item.lineItems[0].description ? item.lineItems[0].description : '';
        let itemNameFirst = item.lineItems[0] ? item.lineItems[0].entityType ? item.lineItems[0].entityType === 'plan_item_price' ? 'Subscription' : 'Top Up' : '' : ''
        let itemNameSecond = this.capitalizeFirstLetter(item.lineItems[0] ? item.lineItems[0].entityId ? item.lineItems[0].entityId.replace('_', ' ') : '' : '')

        let itemName = itemNameFirst !== '' && itemNameSecond !== '' ? itemNameFirst + ' - ' + itemNameSecond : itemNameFirst + itemNameSecond
        // console.log('itemName: ', itemName)

        let workspaceName =
            //item.metadata.length ? item.metadata[2].slice(8).slice(0, -1) :
            localStorage.getItem('workspaceName') ? localStorage.getItem('workspaceName') : ''
        let itemCreated = this.convertDate(item.date ? item.date : '', false)
        let start = this.convertDate(item.lineItems[0].dateFrom, false)
        let end = this.convertDate(item.lineItems[0].dateTo, false)
        // console.log('item: ', item)
        // console.log('itemDetails: ', itemDetails)
        // console.log('itemDetailsTypeof: ', typeof itemDetails)

        let currency = item.currencyCode === 'USD' ? '$' : item.currencyCode === 'EUR' ? '€' : item.currencyCode;
        // console.log('itemDetailsHandle: ', itemDetailsHandle)

        // console.log('email: ', item.billing_details.email)
        let modalData = {
            id: item.id,
            // item: item.outcome && item.outcome.network_status && item.outcome.network_status === 'approved_by_network' ? 'SMS Campaign charge ' : itemName,
            // name: item.account_name,
            name: item.billing_details ? item.billing_details && item.billing_details.billing_name ? item.billing_details.billing_name : '' : '',
            address: item.billing_details ? item.billing_details.address.line1 + ', ' + item.billing_details.address.country : '',
            email: item.billing_details ? item.billing_details.email : '',
            date: itemCreated,
            discount: item.creditsApplied ? item.creditsApplied / 100 : '',
            subtotal: currency + item.subTotal ? item.subTotal / 100 : item.amount / 100,
            total: currency + item.amountPaid / 100,
            project: workspaceName,
            price: itemName === 'Emitto charge' ? currency + item.lineItems[0].amount / 100 : currency + item.total ? currency + item.total / 100 : currency + item.lineItems[0].amount / 100,
            tax: item.tax ? currency + item.tax / 100 : '',
            periodStart: start,
            periodEnd: end,
            quantity: item.lineItems[0].quantity,
            yearly: !!(item.lines && item.lines.data.length && item.lines.data[0].plan && item.lines.data[0].plan.interval === 'year' &&
                item.lines.data[0].plan.interval === 'year' && ((item.lines.data[0].plan.id === 'essentials_yearly') || (item.lines.data[0].plan.id === 'boost_yearly'))),
            type: item.item_type[0],
            amount_refunded: item.amount_refunded ? currency + item.amount_refunded / 100 : '',
            amount: item.lineItems[0] ? currency + item.lineItems[0].amount / 100 : '/',
            companyName: item.billing_details && item.billing_details.company_name ? item.billing_details.company_name : '',
            vatNumber: item.billing_details && item.billing_details.vat_number ? item.billing_details.vat_number : '',
            description: itemDescription,
            currency,
        }
        this.setState({
            showInvoiceModal: true,
            modalData: modalData
        })
    }
    handleChangeCampaignsNumberPerPage = async (value) => {
        await this.setState({
            currentPage: 1,
            pageSize: value,
            lastPage: value > this.state.totalPosts ? true : this.state.lastPage,
            lastPageSize: value > this.state.totalPosts ? this.state.totalPosts : this.state.lastPageSize,
            loader: true
        })

        await this.getPostsData()
    }

    convertDate = (unix_timestamp, completeDate) => {
// Create a new JavaScript Date object based on the timestamp
// multiplied by 1000 so that the argument is in milliseconds, not seconds.

        let miliseconds = unix_timestamp * 1000;

        let toLocal = new Date(miliseconds).toLocaleDateString("en-US");

        let objectDate = new Date(toLocal);
        let fullDate = objectDate.toString();

        let year = fullDate.substring(11, 15);
        let month = fullDate.substring(4, 7);
        let day = fullDate.substring(8, 10);

        // console.log('convertDate: ', day + '. ' + month + ' ' + year)
        if (completeDate) {
            return fullDate
        } else {
            return day + '. ' + month + ' ' + year
        }


    }

    getPreview = async () => {
        if (!this.state.preview) {
            try {
                const add_account_token = 'EAAZAfK9tK44IBADVZBY4gjXJZBqKdAdCqQokgs5uVNiWm9PtZA7L1qvMF6w2qmNcZCPZAfTfZCCtoxhfW0N3KJZBeRkXLMCfpKuq3SNu3Ybvl9R7JSJU337WcOZB4ZCeO2RyZCLBsBN7j5iDk8GyF2FhUAlbI6C6obOPLB2rCekBNYeGQZDZD';
                const add_account_id = 'act_269773933645768';

                // const adsetId = await campaign.adsets.data[0].id || '';
                // const result = await http.get('https://graph.facebook.com/v4.0/' + add_account_id + '/generatepreviews?access_token=' + add_account_token +
                //     '&ad_format=MOBILE_FEED_STANDARD&creative={"type":27, "object_id": 112886416838535}&post={"link":"https://nba.com", "message":"Lorem ipsum dolor sit amet","picture":"http://url.to/your/custom/image.jpg","name":"Facebook","caption":"www.facebook.com","description":"Lorem ipsum dolor sit amet"}')
                const result = await http.get(facebook_app_marketing_url + add_account_id + '/generatepreviews?access_token=' + add_account_token +
                    '&ad_format=MOBILE_FEED_STANDARD&creative={"object_story_spec": {"page_id": "106911734110630", "link_data": { "call_to_action": {"type": "LEARN_MORE", "value": { "link": "https://nba.com" } },"description": "Ovde ide opis", "link": "https://nba.com", "message": "Probna Poruka","name": "Ovde ide ime", "picture": "https://cdn.pixabay.com/photo/2015/12/01/20/28/road-1072823__340.jpg" }}}')

                // Ad formats: DESKTOP_FEED_STANDARD, FACEBOOK_STORY_MOBILE, INSTAGRAM_EXPLORE_CONTEXTUAL, INSTAGRAM_EXPLORE_IMMERSIVE, INSTAGRAM_STANDARD, INSTAGRAM_STORY, INSTANT_ARTICLE_RECIRCULATION_AD, INSTANT_ARTICLE_STANDARD, INSTREAM_VIDEO_DESKTOP, INSTREAM_VIDEO_MOBILE, MESSENGER_MOBILE_INBOX_MEDIA, MESSENGER_MOBILE_STORY_MEDIA, MOBILE_BANNER, MOBILE_FEED_BASIC, MOBILE_FEED_STANDARD, MOBILE_FULLWIDTH, MOBILE_INTERSTITIAL, MOBILE_MEDIUM_RECTANGLE, MOBILE_NATIVE, RIGHT_COLUMN_STANDARD, SUGGESTED_VIDEO_DESKTOP, SUGGESTED_VIDEO_MOBILE, WATCH_FEED_MOBILE"
                // const result = await http.get('https://graph.facebook.com/v5.0/' + add_account_id + '/generatepreviews?access_token=' + add_account_token +
                //     '&ad_format=MOBILE_FEED_STANDARD&creative=[{"object_story_spec": "' + object_story_spec + '"}]')


                const iframe = await result.data.data[0].body;
                await this.setState({preview: iframe})
            } catch (e) {
                //console.log('error: ', e)
            }
        }

    }

    tableLoaderRenderer = () => {
        return <div className='table-loader-container'>
            <ChartLoader/>
        </div>
    }

    handleRowsPerPageChange = async (number) => {
        await this.setState({pageSize: number})
        this.getPostsData();
    };

    getMuiTheme = () => createTheme(Theme)

    render() {
        const columns = [
            {
                name: "invoice_pdf",
                label: " ",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const item = tableMeta.tableData[tableMeta.rowIndex];
                        const invoicePdf = item.invoice_pdf ? item.invoice_pdf.slice(0, -4) : '';
                        const receiptUrl = item.receipt_url ? item.receipt_url : '';
                        return <div className='min-width-70' style={{marginTop: 0}}>
                            {/*{ invoicePdf ?*/}
                            {/*    <a target="_blank" href={ invoicePdf ? invoicePdf : receiptUrl ? receiptUrl : '' }>*/}
                            {/*        <i className='fas fa-eye type-icon'></i>*/}
                            {/*    </a>*/}
                            {/*    :*/}
                            {/*    ''*/}
                            {/*}*/}
                            {
                                //receiptUrl ?
                                <i onClick={() => this.openModal(tableMeta.rowIndex)}
                                   className='fas fa-eye type-icon'></i>
                                // :
                                // ''
                            }
                            {/*{*/}
                            {/*    invoicePdf ?*/}
                            {/*        <a target="" href={ invoicePdf }>*/}
                            {/*            <i className="fas fa-file-download type-icon"></i>*/}
                            {/*        </a>*/}
                            {/*        :*/}
                            {/*        ''*/}
                            {/*}*/}
                        </div>
                    }
                }
            },
            {
                name: "id",
                label: "Invoice #",
                options: {
                    filter: false,
                    sort: true,
                }
            },
            {
                name: "lineItems",
                label: "Type",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value, tableMeta, updateValue) => {

                        //console.info('value:', value)
                        let itemDescription = value[0] && value[0].description ? value[0].description : '';
                        let itemNameFirst = value[0] ? value[0].entityType ? value[0].entityType === 'plan_item_price' ? 'Subscription' : 'Top Up' : '' : ''

                        let itemNameSecond = value[0] ? value[0].entityId ? value[0].entityId.replaceAll('_', " ") : '' : ''


                        const regionACheck = value[0] ? value[0].entityId ? value[0].entityId.includes('region_a') : false : false
                        const regionBCheck = value[0] ? value[0].entityId ? value[0].entityId.includes('region_b') : false : false

                        // console.log('regionAcheck: ', regionACheck)
                        // console.log('regionBcheck: ', regionBCheck)

                        itemNameSecond = regionACheck === true ? 'Region A' : regionBCheck === true ? 'Region B' : itemNameSecond.includes('Phone') ? 'Phone Plan' : itemNameSecond

                        return <div>
                            {
                                itemDescription ? itemDescription : itemNameFirst !== '' && itemNameSecond !== '' ? itemNameFirst + ' - ' + itemNameSecond : itemNameFirst + itemNameSecond
                            }

                        </div>
                    }
                }
            },
            {
                name: "status",
                label: "Status",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const item = tableMeta.tableData[tableMeta.rowIndex];
                        return <div>{item.amount_refunded && item.amount && (item.amount_refunded === item.amount) ? 'Refunded' : item.status}</div>
                    }
                }
            },
            {
                name: "amount",
                label: "Amount",
                options: {
                    filter: false,
                    sort: true,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const item = tableMeta.tableData[tableMeta.rowIndex];
                        let currency = item.currencyCode === 'USD' ? '$' : item.currencyCode === 'EUR' ? '€' : item.currencyCode;
                        return <div>{ currency }{item.amountPaid ? item.amountPaid / 100 : '0.00'}</div>
                    }
                }
            },
            {
                name: "date",
                label: "Date",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const item = tableMeta.tableData[tableMeta.rowIndex];
                        const created = item && item.date ? this.convertDate(item.date) : ''
                        return <div
                            className='min-width-80'>{created ? created : ''}</div>
                    }
                }
            },
        ];

        const options = {
            serverSide: false,
            count: this.state.totalPosts,
            filterType: 'none',
            selectableRows: 'none',
            viewColumns: false,
            rowsPerPage: this.state.pageSize,
            download: false,
            print: false,
            search: false,
            filter: false,
            sort: false,
            onChangeRowsPerPage: (number) => this.handleRowsPerPageChange(number),
            page: this.state.currentPage - 1,
            rowsPerPageOptions: [25, 50, 100],
            textLabels: {
                body: {
                    noMatch: this.state.tableLoader ?
                        this.tableLoaderRenderer()
                        :
                        'There are no invoices to be displayed',
                },
            },
            onTableChange: (action, tableState) => {
                // console.log(action, tableState);

                // a developer could react to change on an action basis or
                // examine the state as a whole and do whatever they want

                switch (action) {
                    case 'changePage':
                        this.handlePageChange(tableState.page + 1);
                        break;
                    case 'sort':
                        this.handleSortContacts(tableState.sortOrder)
                        break;
                    // default:
                    //     console.log('action not handled.');
                }
            }
        };
        return (
            <div className='add-funds-content-container'>
                <div className='white-wrapper'>
                    <h2 className='text-bold'>Invoices</h2>
                    {/*{console.log('state: ', this.state)}*/}
                    {
                        this.state.loader ?
                            this.tableLoaderRenderer()
                            :
                            <MuiThemeProvider theme={this.getMuiTheme()}>
                                <MUIDataTable
                                    title={""}
                                    data={this.state.posts}
                                    columns={columns}
                                    options={options}
                                />
                            </MuiThemeProvider>
                    }
                </div>
                <BillingInvoiceModal
                    width={'800 important!'}
                    modalData={this.state.modalData}
                    showModal={this.state.showInvoiceModal}
                    handleClose={() => this.setState({showInvoiceModal: false})}
                    maxWidth={900}
                    history={this.props.history}
                />
            </div>
        )
    }
}

export default sizeMe()(BillingInvoices);